// extracted by mini-css-extract-plugin
export default {"form":"reset-password_form__TZQ7u"};